import { useOverlaysController } from "@src/overlay";
import { track } from "@util/analytics";

import styles from "./styles.module.scss";

function WaitlistButton() {
  const overlays = useOverlaysController();

  return (
    <button
      className={styles["waitlist-button"]}
      data-cy="open-waitlist-modal"
      onClick={() => {
        track.tap("Landing - SC Waitlist - Join Button");
        overlays.push("landing/waitlist", {});
      }}
      type="submit"
    >
      <span>Join the waitlist</span>
    </button>
  );
}

export default WaitlistButton;
